import React from 'react';

import { styled } from '@this/constants/themes';
import type AirRouteDetail from '@this/domain/flight/air_route_detail';

export const AirRoutePolicies: React.FC<{ airRoutePolicies: AirRouteDetail }> = ({ airRoutePolicies }) => {
  if (!airRoutePolicies.changeReservationPolicies && !airRoutePolicies.cancelPolicies) {
    return null;
  }
  return (
    <Section>
      <Title>航空券の変更・取消条件について</Title>
      {airRoutePolicies.changeReservationPolicies && (
        <>
          <SubTitle>予約の変更</SubTitle>
          <Content>
            {airRoutePolicies.changeReservationPolicies.map((policy, i) => (
              <p key={i.toString()}>{policy}</p>
            ))}
          </Content>
        </>
      )}

      {airRoutePolicies.cancelPolicies && (
        <>
          <SubTitle>取消・払戻し</SubTitle>
          <Content>
            {airRoutePolicies.cancelPolicies.map((policy, i) => (
              <p key={i.toString()}>{policy}</p>
            ))}
          </Content>
        </>
      )}
      <Provided>株式会社オーエフシー(c)</Provided>
    </Section>
  );
};

const Section = styled.section`
  & + & {
    margin-top: 20px;
  }
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
`;

const SubTitle = styled.h3`
  font-weight: bold;
  margin-bottom: 5px;
`;

const Content = styled.div`
  margin-left: 10px;
  margin-bottom: 15px;
`;

const Provided = styled.div`
  text-align: right;
  font-size: 11px;
`;
